<template>
  <b-form-group class="days-form-group">
    <b-form-checkbox-group
      class="days-checkbox-group"
      v-model="dataDays"
      :options="optionDays"
    />
  </b-form-group>
</template>

<script>
  export default {
    name: 'DaysCheckbox',
    model: {
      prop: 'days',
      event: 'change',
    },
    props: {
      days: {
        type: Array,
        default: function () {
          return []
        },
      }
    },
    data: function () {
      return {
        dataDays: this.days,
        optionDays: [
          { text: 'Lunes', value: '0' },
          { text: 'Martes', value: '1' },
          { text: 'Miércoles', value: '2' },
          { text: 'Jueves', value: '3' },
          { text: 'Viernes', value: '4' },
          { text: 'Sábado', value: '5' },
          { text: 'Domingo', value: '6' },
        ]
      }
    },
    watch: {
      dataDays: function (val) {
        this.$emit('change', val);
      },
      days: function (val) {
        this.dataDays = val;
      },
    },
  }
</script>

<style scoped lang="scss">
  .days-form-group {
    margin: $spacer*2 auto $spacer;
  }
  .days-checkbox-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: $spacer*0.5 $spacer*2;
    border: 1px solid rgba($body-color, 0.2);
    border-radius: 10px;
  }
</style>

<style lang="scss">
  .days-checkbox-group {

    & .custom-checkbox input, & .custom-checkbox label {
      cursor: pointer;
    }

    & .custom-checkbox {
      border-radius: 5px;
      padding: 0 0.5rem 0 2rem;
      margin: 0;
      &:hover {
        background-color: $hover-background-color;
      }
    }
  }
</style>